<template>
	<div :class="classes" style="display: inline-block; vertical-align: -0.25em">
		<slot />
	</div>
</template>

<script>
import IconMixin from './IconMixin.js'
export default {
	mixins: [IconMixin]
}
</script>

<style scoped>
.icon-lg {
	width: 17px;
	height: 17px;
}
.icon-sm {
	width: 15px;
	height: 15px;
}
.icon-md {
	width: 16px;
	height: 16px;
}
.icon-xs {
	width: 14px;
	height: 14px;
}
</style>
